<template>
  <div class="live-stream-wrapper">
    <div class="live-holder">
      <video
        ref="live_stream"
        autoplay
        muted
        poster="https://www.gazeta.uz/media/img/2021/01/dXvD5b16113033221664_l.jpg"
      ></video>
      <div class="gradient"></div>
      <router-link
        :to="$i18nRoute({ name: 'LiveStream', params: { category: 'feed' } })"
        class="flat-btn play-btn"
        title="Navigate to Live Stream"
      >
        <i class="fas fa-play"></i>
      </router-link>
      <div class="tagline">
        <div class="circle"></div>
        <span style="padding-left: 0.5em; line-height: 1.25em">LIVE</span>
      </div>
    </div>
  </div>
</template>

<script>
import Hls from "hls.js";
import { ref, onMounted } from "vue";

export default {
  name: "LiveStreamWindow",
  setup() {
    const live_stream = ref(null);

    onMounted(() => {
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource("https://streaming.sevimliplay.tv/eyAic2Vzc2lvbl9pZCI6ImFhMWQxNGJmLTA5ZGItNGJmZC04ZGY0LTdkOGIyNjU4MTMzMCIsICJkb21haW5fbmFtZSI6InN0cmVhbWluZy5zZXZpbWxpcGxheS50diIsICJpcF9hZGRyZXNzIjoiMTk1LjE1OC4yNC4xMTYiLCAiZXhwaXJhdGlvbl9kYXRlIjoiMjA1MC0wMi0wMlQxMjowMDowMFoiLCAic3RyZWFtX25hbWUiOiIxIiwgInN0cmVhbV9wYXRoIjoiL2lwX3Y1IiwgImRhdGFjZW50ZXIiOiJzZXYiLCAiZHJtIjoic3BidHZjYXMiLCAicHJvdG9jb2wiOiJobHMiIH0=/MCwCFDkKX1RQeMiZXukHUEtoJUfCR3hGAhRDf5LdOT4ZxIGPXzCOfJ0IuORf1Q/ip_v5/1.m3u8");
        hls.attachMedia(live_stream.value);
      } else if (
        live_stream.value.canPlayType("application/vnd.apple.mpegurl")
      ) {
        live_stream.value.src =
          "https://streaming.sevimliplay.tv/eyAic2Vzc2lvbl9pZCI6ImFhMWQxNGJmLTA5ZGItNGJmZC04ZGY0LTdkOGIyNjU4MTMzMCIsICJkb21haW5fbmFtZSI6InN0cmVhbWluZy5zZXZpbWxpcGxheS50diIsICJpcF9hZGRyZXNzIjoiMTk1LjE1OC4yNC4xMTYiLCAiZXhwaXJhdGlvbl9kYXRlIjoiMjA1MC0wMi0wMlQxMjowMDowMFoiLCAic3RyZWFtX25hbWUiOiIxIiwgInN0cmVhbV9wYXRoIjoiL2lwX3Y1IiwgImRhdGFjZW50ZXIiOiJzZXYiLCAiZHJtIjoic3BidHZjYXMiLCAicHJvdG9jb2wiOiJobHMiIH0=/MCwCFDkKX1RQeMiZXukHUEtoJUfCR3hGAhRDf5LdOT4ZxIGPXzCOfJ0IuORf1Q/ip_v5/1.m3u8";
      }
    });

    return {
      live_stream,
    };
  },
};
</script>

<style lang="scss" scoped>
.live-stream-wrapper {
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  position: relative;
  border-radius: 4px;
  overflow: hidden;

  .live-holder {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
    }

    .play-btn {
      color: #fff;
      font-size: 1.625em;
      padding: 0.22em 1.2em;
      position: relative;
      border: 1px solid #fff;
      transition: all 0.4s ease, border 0s;

      &:hover {
        color: #121212;
        background-color: #fff;
        border: none;
      }
    }

    .gradient {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-image: linear-gradient(transparent, rgba(18, 18, 18, 0.5));
    }

    .tagline {
      position: absolute;
      color: #fff;
      bottom: 0;
      left: 0;
      text-transform: uppercase;
      padding: 10px 20px;
      pointer-events: none;
      font-weight: 600;
      height: auto;
      display: flex;
      align-items: flex-start;

      .circle {
        width: 1.1em;
        height: 1.1em;
        background-color: #fff;
        border-radius: 50%;
        animation: fade-pulse 1.4s cubic-bezier(0.075, 0.82, 0.165, 1) infinite;
      }
    }
  }
}
</style>
